import { render, staticRenderFns } from "./TwoLabelWLink.vue?vue&type=template&id=31e28a46&scoped=true&"
import script from "./TwoLabelWLink.vue?vue&type=script&lang=js&"
export * from "./TwoLabelWLink.vue?vue&type=script&lang=js&"
import style0 from "./TwoLabelWLink.vue?vue&type=style&index=0&id=31e28a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e28a46",
  null
  
)

export default component.exports